/* Clocked Out — small behaviours for co-* sections */
(function () {
  // Timeline tabs
  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  // Buy box: purchase type, pack choice, gallery
  function initBuyBox(root) {
    var packs = root.querySelectorAll('.co-pack');
    var planBtns = root.querySelectorAll('[data-plan-type]');
    var idInput = root.querySelector('input[name="id"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var now = root.querySelector('[data-price-now]');
    var was = root.querySelector('[data-price-was]');
    var save = root.querySelector('[data-price-save]');
    var saveWrap = root.querySelector('[data-save-wrap]');
    var per = root.querySelector('[data-price-per]');
    var ctaPrice = root.querySelectorAll('[data-cta-price]');
    var mode = root.getAttribute('data-default-plan') || 'otp';

    function current() {
      var sel = root.querySelector('.co-pack[aria-checked="true"]') || packs[0];
      return sel;
    }
    function render() {
      var p = current();
      if (!p) return;
      var canSub = p.getAttribute('data-plan-id');
      var sub = mode === 'sub' && canSub;
      planBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-plan-type') === (sub ? 'sub' : 'otp') ? 'true' : 'false');
      });
      packs.forEach(function (el) {
        var s = mode === 'sub' && el.getAttribute('data-plan-id');
        el.querySelector('[data-pack-price]').textContent = el.getAttribute(s ? 'data-sub' : 'data-otp');
        el.querySelector('[data-pack-per]').textContent = el.getAttribute(s ? 'data-per-sub' : 'data-per-otp');
      });
      idInput.value = p.getAttribute('data-variant');
      planInput.value = sub ? p.getAttribute('data-plan-id') : '';
      planInput.disabled = !sub;
      var price = p.getAttribute(sub ? 'data-sub' : 'data-otp');
      if (now) now.textContent = price;
      ctaPrice.forEach(function (c) { c.textContent = price; });
      if (per) per.textContent = p.getAttribute(sub ? 'data-per-sub' : 'data-per-otp');
      var commit = root.querySelector('[data-commit]');
      if (commit) {
        commit.textContent = '';
        (p.getAttribute(sub ? 'data-commit-sub' : 'data-commit-otp') || '').split('|').forEach(function (l) {
          if (!l) return;
          var e = document.createElement('span'); e.textContent = l; commit.appendChild(e);
        });
      }
      var showSave = sub && p.getAttribute('data-save');
      if (saveWrap) saveWrap.hidden = !showSave;
      if (showSave) { was.textContent = p.getAttribute('data-otp'); save.textContent = p.getAttribute('data-save'); }
    }
    packs.forEach(function (el) {
      el.addEventListener('click', function () {
        packs.forEach(function (o) { o.setAttribute('aria-checked', o === el ? 'true' : 'false'); });
        render();
      });
    });
    planBtns.forEach(function (b) {
      b.addEventListener('click', function () { mode = b.getAttribute('data-plan-type'); render(); });
    });
    var thumbs = root.querySelectorAll('.co-bb__thumb');
    var main = root.querySelector('.co-bb__main img');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        if (main) { main.src = t.getAttribute('data-full'); main.srcset = ''; main.alt = t.getAttribute('data-alt') || ''; }
      });
    });
    render();
  }

  // Mobile menu
  function initMenu(root) {
    var btn = root.querySelector('.co-menu-toggle');
    var nav = root.querySelector('.co-mobile-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.hasAttribute('open');
      if (open) nav.removeAttribute('open'); else nav.setAttribute('open', '');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-co-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-co-buybox]').forEach(initBuyBox);
    (scope || document).querySelectorAll('[data-co-header]').forEach(initMenu);
  }

  // Section blending: each section's top and bottom fade into its neighbours' colours
  function coBlend() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    function layers(v) { var out = [], d = 0, cur = ''; for (var i = 0; i < v.length; i++) { var c = v[i]; if (c === '(') d++; if (c === ')') d--; if (c === ',' && !d) { out.push(cur.trim()); cur = ''; } else cur += c; } if (cur.trim()) out.push(cur.trim()); return out; }
    function rgb(s) { var m = s && s.match(/rgba?\(([^)]+)\)/); if (!m) return null; var p = m[1].split(',').map(parseFloat); return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 }; }
    function css(c, a) { return 'rgba(' + Math.round(c.r) + ',' + Math.round(c.g) + ',' + Math.round(c.b) + ',' + (a == null ? 1 : a) + ')'; }
    function mix(a, b, t) { t = t == null ? .5 : t; return { r: a.r + (b.r - a.r) * t, g: a.g + (b.g - a.g) * t, b: a.b + (b.b - a.b) * t, a: 1 }; }
    var VIO = { r: 116, g: 70, b: 187, a: 1 };
    function diff(a, b) { return Math.abs(a.r - b.r) + Math.abs(a.g - b.g) + Math.abs(a.b - b.b); }
    function edges(el) {
      var cs = getComputedStyle(el), img = cs.backgroundImage;
      var lin = layers(img === 'none' ? '' : img).filter(function (l) { return /^linear-gradient/.test(l); }).pop();
      if (lin) {
        var st = (lin.match(/rgba?\([^)]+\)/g) || []).map(rgb).filter(function (c) { return c.a > .9; });
        if (st.length) return { top: st[0], bottom: st[st.length - 1] };
      }
      var bg = rgb(cs.backgroundColor);
      if (bg && bg.a > .9) return { top: bg, bottom: bg };
      return null;
    }
    var items = [];
    [].forEach.call(main.children, function (w) {
      var el = [].filter.call(w.children, function (c) { return !/^(STYLE|SCRIPT|LINK)$/.test(c.tagName); })[0];
      if (el && el.offsetHeight) items.push(el);
    });
    var foot = document.querySelector('.co-footer');
    if (foot) items.push(foot);
    items.forEach(function (el) {
      if (el.dataset.coBlend) { el.style.backgroundImage = el.dataset.coBgInline; el.style.backgroundSize = el.dataset.coBgSize; el.style.backgroundPosition = el.dataset.coBgPos; el.style.backgroundRepeat = el.dataset.coBgRep; }
      else { el.dataset.coBlend = '1'; el.dataset.coBgInline = el.style.backgroundImage; el.dataset.coBgSize = el.style.backgroundSize; el.dataset.coBgPos = el.style.backgroundPosition; el.dataset.coBgRep = el.style.backgroundRepeat; }
    });
    var info = items.map(function (el) { return { el: el, e: edges(el), band: el.classList.contains('co-marquee') || el.offsetHeight < 140, top: null, bottom: null }; });
    for (var i = 0; i < info.length - 1; i++) {
      var A = info[i], B = info[i + 1];
      if (!A.e || !B.e || diff(A.e.bottom, B.e.top) < 12) continue;
      if (A.band || B.band) continue;
      var d = diff(A.e.bottom, B.e.top), m = mix(mix(A.e.bottom, B.e.top), VIO, Math.min(.55, d / 700));
      A.bottom = m; B.top = m;
    }
    info.forEach(function (x) {
      if (!x.top && !x.bottom) return;
      var el = x.el, cs = getComputedStyle(el), h = el.offsetHeight;
      var fh = Math.round(Math.max(90, Math.min(240, h * 0.24)));
      var L = [], S = [], P = [], R = [];
      if (x.top) { L.push('linear-gradient(180deg,' + css(x.top) + ' 0,' + css(mix(mix(x.top, x.e.top, .5), VIO, .12), .75) + ' 45%,' + css(x.e.top, 0) + ' 100%)'); S.push('100% ' + fh + 'px'); P.push('0 0'); R.push('no-repeat'); }
      if (x.bottom) { L.push('linear-gradient(0deg,' + css(x.bottom) + ' 0,' + css(mix(mix(x.bottom, x.e.bottom, .5), VIO, .12), .75) + ' 45%,' + css(x.e.bottom, 0) + ' 100%)'); S.push('100% ' + fh + 'px'); P.push('0 100%'); R.push('no-repeat'); }
      var img = cs.backgroundImage;
      if (img && img !== 'none') { L.push(img); S.push(cs.backgroundSize); P.push(cs.backgroundPosition); R.push(cs.backgroundRepeat); }
      el.style.backgroundImage = L.join(',');
      el.style.backgroundSize = S.join(',');
      el.style.backgroundPosition = P.join(',');
      el.style.backgroundRepeat = R.join(',');
    });
  }
  var coBlendT;
  function coBlendSoon() { clearTimeout(coBlendT); coBlendT = setTimeout(coBlend, 120); }
  window.addEventListener('load', coBlend);
  window.addEventListener('resize', coBlendSoon);
  document.addEventListener('shopify:section:load', coBlendSoon);
  document.addEventListener('shopify:section:unload', coBlendSoon);
  document.addEventListener('shopify:section:reorder', coBlendSoon);
  // Buy buttons: on a page with a buy box, links to the product scroll down to it instead of leaving the page
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !/\/products\//.test(a.getAttribute('href') || '')) return;
    if (a.closest('header, footer, nav, [data-co-header], .co-footer, .co-mobile-nav, [data-co-buybox]')) return;
    var box = document.querySelector('[data-co-buybox]');
    if (!box) return;
    var target = box.closest('section') || box;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  });
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
